import React, { useState, useEffect } from 'react';
import {
  Table, Thead, Tbody, Tr, Th, Td, Button, Modal, ModalOverlay, ModalContent,
  ModalHeader, ModalBody, ModalFooter, useDisclosure, Badge, Flex, IconButton,
  Box
} from '@chakra-ui/react';
import { AddIcon } from '@chakra-ui/icons';
import RegistroContratista from '../Ventanas/RegistroContratista';

const TablaRegistroContratista: React.FC = () => {
  const [data, setData] = useState<any[]>([]);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [modo, setModo] = useState<'view' | 'edit' | 'new'>('view');
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/obras/registro-contratista`)
      .then(res => res.json())
      .then(setData)
      .catch(console.error);
  }, []);

  const openModal = (item: any, tipo: 'view' | 'edit') => {
    setSelectedItem(item);
    setModo(tipo);
    onOpen();
  };

  const openNuevo = () => {
    setSelectedItem(null);
    setModo('new');
    onOpen();
  };

  return (
    <Box overflowX="auto" borderRadius="md" boxShadow="md" bg="white" p={4}>
         <Table variant="simple" size="sm">
         <Thead bg="#5b182b">
          <Tr>
            <Th color="white">ID</Th>
            <Th color="white">Razón Social</Th>
            <Th color="white">Representante</Th>
            <Th color="white">RFC</Th>
            <Th color="white">Teléfono</Th>
            <Th color="white">Acciones</Th>
          </Tr>
        </Thead>
        <Tbody>
          {data.map((item) => (
            <Tr key={item.id}>
              <Td>{item.id}</Td>
              <Td>{item.razonSocial}</Td>
              <Td>{item.representante}</Td>
              <Td>{item.rfc}</Td>
              <Td>{item.telefono}</Td>
              <Td>
                <Button size="xs" onClick={() => openModal(item, 'view')}>Ver</Button>{' '}
                <Button size="xs" onClick={() => openModal(item, 'edit')}>Editar</Button>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>

      <Flex justify="center" mt={4}>
        <IconButton
          icon={<AddIcon />}
          aria-label="Agregar nuevo"
          colorScheme="green"
          borderRadius="full"
          size="lg"
          position="fixed"
          bottom="20px"
          right="20px"
           zIndex={10} 
          onClick={openNuevo}
        />
      </Flex>

      <Modal isOpen={isOpen} onClose={onClose} size="6xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {modo === 'view' && 'Ver Registro de Contratista'}
            {modo === 'edit' && 'Editar Registro de Contratista'}
            {modo === 'new' && 'Nuevo Registro de Contratista'}
          </ModalHeader>
          <ModalBody>
            <RegistroContratista modo={modo} data={selectedItem} onSubmit={() => { onClose(); window.location.reload(); }} />
          </ModalBody>
          <ModalFooter>
            <Button onClick={onClose}>Cerrar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default TablaRegistroContratista;